import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import Tags from '../common/Tags';
import { formatBusinessText } from '../../utils/textFormatting';

const CardsTable = ({ data, onDelete, onView, onEdit }) => {
  const renderTags = (row) => {
    let tags = [];
    
    if (row.widgetData && row.widgetData.results && row.widgetData.results.tags) {
      tags = row.widgetData.results.tags;
    } else if (row.tags) {
      tags = typeof row.tags === 'string' ? row.tags.split(',').map(t => t.trim()) : row.tags;
    }
    
    return tags.length > 0 ? <Tags tags={tags} sx={{ mt: 0, pt: 0, borderTop: 'none' }} /> : null;
  };

  const formatColumnNames = (columnString) => {
    if (!columnString) return '';
    
    const columns = columnString.split(',').map(col => col.trim());
    const formattedColumns = columns.map(col => formatBusinessText(col));
    
    return formattedColumns.join(', ');
  };

  return (
    <TableContainer component={Paper} className="cards-table-container">
      <Table className="cards-table">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Card Name</TableCell>
            <TableCell>Card Type</TableCell>
            <TableCell>Card Data Elements</TableCell>
            <TableCell>Keywords</TableCell>
            <TableCell align="right" style={{ width: '8.75rem' }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length > 0 ? (
            data.map((row, index) => (
              <TableRow key={row.widgetId || `row-${index}`} className="cards-table-row">
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.cardName}</TableCell>
                <TableCell>{row.cardType}</TableCell>
                <TableCell>{formatColumnNames(row.cardDataElement)}</TableCell>
                <TableCell>{renderTags(row)}</TableCell>
                <TableCell align="right" style={{ width: '8.75rem' }}>
                  {onView && (
                    <Tooltip title="View card">
                      <IconButton onClick={() => onView(index)} size="small" className="cards-action-button" aria-label="View card">
                        <VisibilityIcon fontSize="small" style={{ color: 'black' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {onEdit && (
                    <Tooltip title="Edit columns and rerun">
                      <IconButton onClick={() => onEdit(index)} size="small" className="cards-action-button" aria-label="Edit columns and rerun">
                        <EditIcon fontSize="small" style={{ color: 'black' }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Tooltip title="Delete">
                    <IconButton onClick={() => onDelete(index)} size="small" className="cards-delete-button" aria-label="Delete">
                      <DeleteIcon fontSize="small" style={{ color: 'black' }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center" className="cards-table-empty">
                No widgets added yet. Click "Add" buttons in the sidebar to create widgets.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CardsTable;
